module.exports = __webpack_public_path__ + "LatoLatin-BoldItalic.e22cd5242829916ff8a5.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-BoldItalic.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-BoldItalic.ttf
// module chunks = styles